import Collection from "../../data-structures/collection"
import Resources from "../../resources/resources"
import Event from "./event"
import DatetimeUtils from "../../gd/utils/datetime-utils"
import calendar_createTaskEvent from "../../gd-model/event/data-container/functions/create-task-event"
import calendar_createMeetingEvent from "../../gd-model/event/data-container/functions/create-meeting-event"
import {EventType} from "../../gd/const/event"
import {momentRange} from "../../gd/convert/moment-range";
import {EventsGroupedByDate} from "./@types"

export default class EventsCollection extends Collection<Event> {

    constructor(models: any) {
        super(models);
    }

    static initFromResources(resources: Resources, params?: {
        includeTasks?       : boolean
        taskEventType?      : EventType
        includeMeetings?    : boolean
    }): EventsCollection {

        let events = resources.events?.models.slice() || []

        // add tasks to events as event objects
        if (params?.includeTasks && params?.taskEventType) {
            events = events.concat(_.map(resources.tasks?.models, t => new Event(calendar_createTaskEvent(t, params?.taskEventType!))))
        }

        // add meetings to events as event objects
        if (params?.includeMeetings) {
            events = events.concat(_.map(resources.meetings?.models, m => new Event(calendar_createMeetingEvent(m))))
        }

        return new EventsCollection(events)
    }

    static initFromJson(data: any): EventsCollection {
        const models: Event[] = []

        _.map(data, (record: any) => {
            models.push(new Event(record))
        })

        return new EventsCollection(models);
    }

    // for Glist support
    public get items(): any[] {
        return this.models
    }

    groupedByDate(forceToday: boolean = false): EventsGroupedByDate[] {
        let res: any[] = []
        const groups: any = {}

        // filter out all events without start date just in case
        const filteredModels = _.filter(this.models, (event: Event) => !!event.startDate)
        // order all models by startDate
        const orderedModels = _.orderBy(filteredModels, (event: Event) => event.startDate?.format("x"))

        // add event to group
        const addEventToGroup = (moment: Moment, event: Event) => {
            const dateString = DatetimeUtils.momentToDate(moment)!
            if (!groups[dateString]) {
                groups[dateString] = {
                    date    : moment,
                    items   : []
                }
            }

            groups[dateString].items.push(event)
        }

        // for all ordered events determine how many days it occupies and add it to every group required
        _.map(orderedModels, (event: Event) => {
            if (!!event.endDate) {
                const datesRange = momentRange(event.startDate!, event.endDate)
                const arrayDays = Array.from(datesRange.by('days'))
                _.map(arrayDays, (dayMoment: Moment) => {
                    addEventToGroup(dayMoment, event)
                })
            } else {
                addEventToGroup(event.startDate!, event)
            }
        })

        // convert groups map to array
        _.mapKeys(groups, (value: any, key: string) => {
            // order all events of one day groups by name (title)
            value.items = _.orderBy(value.items, (event: Event) => event.name.toLowerCase())
            res.push(value)
        })

        if (forceToday) {
            const today = moment()
            const hasToday = _.find(res, group => group.date.isSame(today, 'day'));
            if (!hasToday) res.push({date: today, items: []})
            res = _.orderBy(res, group => group.date.format('x'));
        }

        return res;
    }
}